module.exports = __webpack_public_path__ + "img/interview.1dffcc4d.png";